<template>
  <div class="app">
    <!-- Header -->
    <header class="header">
      <h1 :style="{ fontSize: currentSize + 'px' , height:currentSizeA + 'px' }">300B2區 雙和獅子會</h1>
      <p :style="{ fontSize:currentSizeA + 'px' , height:currentSizeA + 'px'}">雙和十九  卓越長久</p>
    </header>




    <!-- Category Tabs -->
    <div class="tabs">
      <button
        v-for="c in categories"
        :key="c"
        :style="{ fontSize: currentSizeA + 'px' }"
        :class="['tab', activeCategory === c ? 'active' : '']"
        @click="activeCategory = c"
      >
        {{ c }}
      </button>
    </div>

    <!-- Product List -->
    <div class="product-list">
      <div
        class="card"
        v-for="item in filteredMenu"
        :key="item.id"
      >
        <img :src="item.image" class="thumb" />
        <div class="info">
          <h3>{{ item.name }}</h3>
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <div class="product-list">
      <div
        class="card"
        v-for="item in filteredMenu1"
        :key="item.id"
      >
        <img :src="item.image" class="thumb1" />
        <div class="info">
          <h3>{{ item.name }}</h3>
        </div>
      </div>
    </div>

    <div class="product-list">
      <div
        class="card"
        v-for="item in filteredMenu2"
        :key="item.id"
      >
        <img :src="item.image" class="thumb2" />
        <div class="info2">
          <h3>{{ item.name }}</h3>
        </div>
      </div>
    </div>

    <div class="product-list">
      <div
        class="card"
        v-for="item in filteredMenu3"
        :key="item.id"
      >
        <img :src="item.image" class="thumb3" />
        <div class="info3">
          <h3>{{ item.name }}</h3>
        </div>
      </div>
    </div>

    <div class="product-list">
      <div
        class="card"
        v-for="item in filteredMenu4"
        :key="item.id"
      >
        <img :src="item.image" class="thumb4" />
        <div class="info">
          <h3>{{ item.name }}</h3>
        </div>
      </div>
    </div>
    <div class="sys-01">
      <div
        v-for="item in filteredMenu5"
        :key="item.class"
      >
      <div class="info"></div>
        <h2>第一章：總則</h2>
        <p>第一條：本會定名為國際獅子會台灣總會新北市雙和獅子會，簡稱新北市雙和獅子會（以下稱本會）。</p>
        <p>第二條：本會為依人民團體法設立，非以營利為目的之社會團體。</p>
        <p>第三條：本會以［服務為先、熱心奉獻］為宗旨。</p>
        <p>第四條：本會以新北市行政區域為組織區域，會址設於中華民國台灣省新北市。</p>
        <h2>第二章：宗旨</h2>
        <p>第五條：本會宗旨如下：</p>
        <p>1.	發揚人類博愛互助精神。</p>
        <p>2.	增進國際間友好關係。</p>
        <p>3.	尊重自由啟發智慧。</p>
        <p>4.	提倡社會福利。</p>
        <p>5.	促進國家安全。</p>
        <h2>第三章：任務與目標</h2>
        <p>第六條：本會任務如下：</p>
        <p>1.	舉辦或協辦社區福利事項。</p>
        <p>2.	促進國際工商合作與文化交流。</p>
        <p>3.	協助市政及農村建設。</p>
        <p>4.	促進衛生保健工作。</p>
        <p>5.	促進社會公共關係。</p>
        <p>6.	參加國際獅子會之各種活動。</p>
        <p>第七條：本會目標如下：</p>
        <p>1.	增進國際融和，促進世界大同。</p>
        <p>2.	弘揚仁政理論，培育優秀公民。</p>
        <p>3.	恪守道德規範，關懷社會福祉。</p>
        <p>4.	加強會際交流，團結鞏固獅誼。</p>
        <p>5.	熱心討論公益，避涉政教爭議。</p>
        <p>6.	不求個人利益，永固會務昌隆。</p>
        <h2>第四章：會員</h2>
        <p>第八條：會員資格之取得：</p>
        <p>凡設籍台北地區及在社會上有正當職業、品性良好，年滿二十歲以上者，有行為能力，贊同本會宗旨，並願履行本會章程規定及遵守內規細則之義務者，經會員一至二人推薦，填具入會申請書，由本會審核小組審查，通過後發函本會會員均無異議，並提送理事會同意，且繳交入會費新台幣壹萬元及一年會費叁萬元、會館基金壹仟元、月例會餐費伍仟元整後，得加入本會。</p>
        <p>第九條：榮譽顧問及榮譽會長：</p>
        <p>1.	凡非本會會員，而對本會會務有特別贊助及貢獻者，得由本會理事會決議聘請為榮譽顧問。每屆榮譽顧問不得超過二位，聘期一年，並得由本會理事會決議續聘之。</p>
        <p>2.	凡於國際獅子會或其各分會曾擔任會長以上之職務，申請轉入本會成為本會會員者，若對本會有特殊貢獻，得給予榮譽會長稱謂。不具特殊貢獻者，為一般會員，且依本會規章辦理。</p>
        <p>3.	前項所稱特殊貢獻，指轉入本會前對本會樂捐達新台幣壹拾萬元以上，且連續五年每年樂捐伍萬元以上者。</p>
        <p>4.	前項樂捐款項應存入專戶基金，當屆不得使用。但創會成立授證前入會之創會員樂捐款項不在此限。</p>
        <p>第十條：會員資格之取消：</p>
        <p>1.	會員欠繳會費，經財務以書面正式通知繳納，逾六十日仍未繳納者，秘書應將其姓名及欠繳事實提交理事會，決定是否取消或保留其會員資格。</p>
        <p>2.	會員違反本章程、本會內規細則或會員大會決議者，經理監事會提議，並經會長或前會長提請全體會員三分之二連署同意後，取消其會員資格。</p>
        <p>第十一條：本會會員權利：</p>
        <p>1.	發言權及表決權。</p>
        <p>2.	選舉權及被選舉權。</p>
        <p>3.	本會所舉辦各類活動之福利。</p>
        <p>4.	其他依本章程、本會內規細則、會員大會決議或理、監事會議決議應享之權利。</p>
        <p>第十二條：本會會員義務：</p>
        <p>1.	遵守本會章程、內規細則及會員大會決議。</p>
        <p>2.	擔任本會所指派之職務。</p>
        <p>3.	繳納會費及社會服務。</p>
        <p>4.	出席本會之各項會議與會務活動。</p>
        <h2>第五章：組織</h2>
        <p>第十三條：本會以會員大會為最高權力機構，在會員大會開會期間，理、監事會代行其職權。</p>
        <p>第十四條：本會設理事25人、監事5人由會員中選舉產生，理、監事之任期各為一年，均於任期屆滿時改選之，但連選得連任。</p>
        <p>第十五條：本會設常務理事7人常務監事1人由理監事中分別互選之。</p>
        <p>第十六條：本會設會長一人，任期一年。會長為當然理事長，綜理會務，對外代表本會。</p>
        <p>第十七條：本會設副會長三人，任期均為一年。副會長襄助會長處理會務，依序為第一副會長、第二副會長、第三副會長，並以此順序接任會長為原則。如第一副會長因故不能接任時，得由第二副會長接任之，以此類推。</p>
        <p>第三副會長之選任應於提名委員會召開前，發函通知符合資格之會員，並以提名委員會提名第三副會長人選前十五日為登記截止時間。登記截止後，由提名委員會審查登記會員之資格，提出候選人名單，再於每年四月召開之會員大會時，由全體會員選出。</p>
        <p>第十八條：提名委員會由首屆會長、會長、前屆會長、第一副會長、第二副會長、第三副會長及理、監事組成。當屆會長須於每年三月份舉辦提名委員會，費用由當屆會長支付第一、二、三副會長任內，因故不能勝任者，提名委員會得向會員大會建議保留職務或改為其他職務，並另提適當候選人，由會員大會選舉之。</p>
        <p>第十九條：秘書、財務、總管、連絡，由會長推薦後於會員大會時經認可後聘任之。</p>
        <p>秘書及財務需具有本會連續兩年以上會籍。但本會第一屆及第二屆不在此限。</p>
        <p>第二十條：本會得視會務情形之需要，設置若千委員會以辦理專門業務活動，委員會設主席一人，委員若干人。</p>
        <p>第二十一條：本會接任會長得編製年度計劃書及年度組織表含各委員會人員、年度財務預筆書，俾利委員會據以辦理專門會務活動。委員會設召集人一人，委員若干人，並提送當屆三月份理監事會審查通過後由理、監事聯席會於會員大會提案通過後執行。</p>
        <p>第二十二條：本會設助理秘書一人，任期一年，協助會長處理會務及文作業。人選由接任會長於每届四月份會員大會提案，內容包含薪資，年終獎金、工作範團，經會員大會通過後聘任（届任助理秘書由接任會長決定是否續聘或另聘他人接任，聘任助提秘書每月薪資含年終獎金上限為新台幣壹萬元）</p>
        <h2>第六章：會議</h2>
        <p>第二十三條：本會會員大會於每年四月份舉行一次，必要時得由理事會或監事會五人以上提議，召開臨時會員大會。</p>
        <p>第二十四條：理、監事會每一個月各舉行一次，必要時得舉行臨時理、監事會議。</p>
        <h2>第七章：職權</h2>
        <p>第二十五條：理事會之職權：</p>
        <p>1.	執行本會章程所規定之會務。</p>
        <p>2.	執行會員大會之決議。</p>
        <p>3.	執行監事會提請之事項。</p>
        <p>4.	有關徵求會員之事項。</p>
        <p>5.	本會經費及基金之籌劃。</p>
        <p>6.	本會預算、決算之編制。</p>
        <p>第二十六條：監事會之職權：</p>
        <p>1.	本會工作之審核。</p>
        <p>2.	本會財務收支之審核。</p>
        <p>3.	本會會員違反會章之審核。</p>
        <p>第二十七條：理、監事會閉會期間，常務理、監事分別代行其職務。</p>
        <h2>第八章：經費</h2>
        <p>第二十八條：本會經費來源：</p>
        <p>1.	會費。</p>
        <p>2.	捐贈。</p>
        <p>3.	基金之孳息。</p>
        <p>4.	其他收入。</p>
        <h2>第九章：附則</h2>
        <p>第二十九條：除本章程外，本會另訂內規細則，視同本章程之一部份。</p>
        <p>第三十條：本章程若有設置章程施行細則之必要時，得日理事會擬定實施之。</p>
        <p>第三十一條：本章程經會員大會通過，呈請主管機關備案後施行。</p>
        <p>第三十二條：本章程如有未盡事宜，依政府有關法令及國際總會章則為準。</p>
      </div>
    </div>   
    <div class="sys-02">
      <div
        v-for="item in filteredMenu6"
        :key="item.class"
      >
      <div class="info"></div>
        <h2>第一條：設立宗旨</h2>
        <p>本會成立以秉持獅子主義之精神，集合全體力量，服務社會貢獻國家。</p>
        <h2>第二條：經費</h2>
        <p>1.	第四屆起會員應於每年6月1日起開始繳交年費新台幣參萬元及會館基金新台幣壹仟元、月例會餐費新台幣伍仟元，並於6月30日前繳交完成，開支票者票期應為每年7月31日前，會館基金應存入本會專戶基金。</p>
        <p>2.	第二屆起新入會會員除應繳交年費外，另須繳交入會費新台幣壹萬元存入專戶基金。</p>
        <p>3.	本會年度經費預算須經會員大會審查通過後，提交理事會執行，不得任意變更。</p>
        <p>4.	本會如需捐款，應由會員自由捐獻，不得強執行。</p>
        <p>5.	每屆結餘之經費，應存入專戶基金，下屆不得使用。</p>
        <p>所結存的專戶基金用途如下：</p>
        <p>A.	每逢五年大屆之獅兄、獅嫂會制服。</p>
        <p>B.	購置會館之基金。</p>
        <p>C.	國家急難救助之使用，但每次上限金額為新台幣壹拾伍萬元。</p>
        <p>附則：以上B、C項須經會員大會會議通過後，方能提撥款項使用。</p>
        <p>6.	本會當屆會長應職務捐款新台幣壹拾萬元，前任會長應職務捐款新台幣貳萬元，第一副會長應職務捐款新台幣伍萬元，第二副會長應職務捐款新台幣肆萬元，第三副會長應職務捐款新台幣參萬元，職務捐款為當屆會務使用。</p>
        <p>7.	以民意代表配合款項為社會服務，須專款專用，不得有回扣，也不得以本會名義配合民意代表為不實之社會服務消化配合款項。</p>
        <h2>第三條：本會編制</h2>
        <p>1.	本會會員人數以100名為最高上限。</p>
        <p>2.	本會職稱：創會會長、前會長、前任會長、會長、導獅、榮譽顧問。會職人員職稱：第一副會長、第二副會長、第三副會長、秘書、財務、總管、連絡。理、監事職稱：理事長、常務理事、理事、候補理事、常務監事、監事、候補監事。</p>
        <p>3.	當屆會長不得再另行增設會職人員或副會職人員。</p>
        <p>4.	導獅及榮譽顧問社會服務金由當屆會務使用。</p>
        <h2>第四條：理、監事聯席會議及月例會</h2>
        <p>1.	本會於每月第三個星期日下午五時準時召開理、監事聯席會議及月例會，每年四月份第三個星期日下午五時準時召開會員大會。如有專題演講、配合節日等事由，可更改日期提前或延後召開，惟須事先在理、監事聯席會議中提案通過。另9月份總監訪問聯合例會配合第十分區舉辦。4、6、9月份理、監事聯席會議依下述第2點辦理。</p>
        <p>2.	本會理、監事聯席會議每年4月份第一次會議於會員大會選舉後召開、餘依序為6月份第二次、7月份第三次、8月份第四次、9月份第五次、10月份第六次、11月份第七次、12月份第八次、翌年1月份第九次、2月份第十次、3月份第十一次、4月份第十二次。理、監事聯席會議配合月例會日期召開分別為7、8、10、11、12、1、2、3月份；獨立召開為4、6、9月份，於當月第一個星期日舉行，當次會議由會長及秘書處主辦，餐費由當屆會費編列支付，酒、飲料由當屆會長支付。</p>
        <p>說明：4月份是當屆最後一次理、監事聯席會議不能與下屆會員大會同時召開，6月份要配合會長交接及審查接續籌備會長交接事宜，含接任屆7月份會務、工作報告，9月份要配合總監訪問暨第十分區聯合例會。</p>
        <p>3.	理、監事聯席會議，會員可提前來旁聽，但無表決權及發言權。同來的獅嫂可旁聽，但無表決權及發言權。獅嫂對本會有提議或建議可透過獅兄表達。非擔任理、監事獅兄對本會有提議或意見可透過理監事獅兄代為提案表達。</p>
        <p>4.	理、監事聯席會議結束後接續舉辦月例會，會後邀請獅兄、獅嫂聚餐舉行獅子之夜，與會者須準時出席，以示隆重。</p>
        <p>5.	會長及內閣人員，如因故無法與會，應找職務代理人，以利會義進行。</p>
        <p>6.	會員配偶嚴禁干涉會務，挑撥離間、散播謠言、製造是非、耳語者，第一次被查到者應辦桌請客道歉第二次被查到者經理、監事聯席會議決議後，禁止前來參加本會所有活動。</p>
        <p>7.	理、監事聯席會議結束後，會議記錄及財務報表應附在下次月例會通知函內寄給全體獅兄。</p>
        <h2>第五條：獎懲辦法</h2>
        <p>1.	理、監事聯席會議、月例會、獅子之夜及社會服務等活動，與會者應準時到場開會並踴躍參與活動。</p>
        <p>2.	理、監事聯席會議、月例會之出席，獅兄、獅嫂設全勤獎以資鼓勵。</p>
        <p>3.	對會務有特殊貢獻及有功人員設金獅獎、銀獅獎、銅獅獎各若干名予以獎勵，遇無則從缺。</p>
        <p>4.	前項人員推選，由當屆會長推薦或公開接受推薦，並於每年5月份月例會之獅子之夜頒獎。</p>
        <p>5.	本會會員及獅嫂有事者，不能前來參加月例會，請向聯絡提早請假。</p>
        <p>6.	本會會員及獅嫂參加月例會不得遲到，遲到之定義以通知書上所定之時間後第11分鐘開始起算。</p>
        <h2>第六條：月例會餐會、社會服務活動</h2>
        <p>1.	當屆會長、秘書應在當月理、監事聯席會議召開前二個月，告知月例會、社會服務主辦之組長及組員籌備舉辦及協助辦理。</p>
        <p>2.	每月月例會餐會活動，由當屆會長依會員人數編列適當預算，分組主辦，月例會餐費所需經費於每年度會員繳納會費時一併收取，以伍仟元為基準。每月餐費以桌計，每桌餐標應以柒仟元為準，並依市價行情酌於調整，另酒水雜費則依往例處理之。組長選擇場地及定訂桌價與桌數需與當屆會長共同討論決定之。經費如有不足則由當屆其他活動經費補充，以利活動順利完成。組長需聯絡告知主辦餐廳、地址、日期、時間、內容、費用等事項會同主辦，會長及秘書處協辦。</p>
        <p>3.	每月月例會、社會服務活動主辦之組長，應於前月理、監事聯席會議報告籌備經過。</p>
        <p>4.	非經本會邀請之人士，不得參加理、監事聯席會議及月例會餐會。每年父親節、歲末聯歡晚會、母親節則隆重邀請會員父母親及子女參加獅子之夜或一日遊。其他特別節日則由會長或理、監事聯席會議決議邀請參加餐會之人士。非經本會通過邀請之人士參加，組長得向參加者收費，每人應繳新台幣陸佰元（大活動不在此限）。</p>
        <p>5.	每月社會服務及獅友交誼由會編列適當預算，分組主辦執行，主辦組如需要增加服務費用可由組長、組員、本會會員或尋找各友會及外面人士自由樂捐（視個人意願不得強迫）。</p>
        <h2>第七條：會長交接及理、監事</h2>
        <p>1.	本會會長交接經費由接任屆編列預算支付並主辦，卸任屆協辦，以莊嚴隆重不奢華浪費為原則；小屆獨立交接費用上限為新台幣貳拾伍萬元，每五年大屆授證及交接典禮費用上限為新台幣參拾萬元，小屆聯合交接費用上限為新台幣壹拾伍萬元，超支之不足費用由接任屆會長支付。</p>
        <p>2.	本會會員於會長交接及其他本會所舉辦之活動，避免贊助金錢或節目等，以減少日後產生無謂之糾紛（會外人士不受此限，會外人士贊助本會得公佈，贊助個人不得公佈）。</p>
        <p>3.	交接時本會會員須致贈接任會長匾額一面，金額由接任屆編列費用匾額金額不得超出新台幣玖千元，接任會長可自由選擇匾額大小、材質或其他贈品。</p>
        <p>4.	本會每逢五年大屆訂製獅兄西裝會服乙套，不得超過新台幣伍仟伍佰元。獅嫂會服乙套，不得超過新台幣肆仟元。會長須補助每位獅兄西裝會服新台幣貳仟元，不足數及獅嫂會服經費由專戶基金提款支付。但超過規定金額部分由當屆會長個人補足。</p>
        <p>5.	非逢五年大屆之各屆新加入會員西裝會服及獅嫂會服則由接任屆會費支付，不得使用專戶基金，當屆會長須補助每位獅兄西裝會服新台幣貳仟元。</p>
        <p>6.	歷屆會長所收B2區及各友會之禮金須存入專戶基金。專分區、母會、國內、外結盟會之兄弟、姐妹會之社會服務金則用當屆使用。</p>
        <p>7.	每屆會長必須贈送會員襯衫乙件、領帶乙條、皮帶乙條、領帶夾乙組。</p>
        <p>8.	本會之理、監事需由每年4月份會員大會之會員互選產生，理事長、常務理、監事則由理、監事互選產生（會長是當屆當然理事長）。</p>
        <h2>第八條：副會長產生及資格</h2>
        <p>1.	本會每屆第三副會長需經會員大會選舉產生。</p>
        <p>2.	其候選資格如下：</p>
        <p>a.	當屆卸任秘書為當然候選人。</p>
        <p>b.	有意參選，必須具有三年以上獅子會齡，曾擔任內閣或理、監事，出席率在80%以上，經理、監事聯席會議通過給予提名參選。</p>
        <p>3.	其順位為第三副會長接任第二副會長，第二副會長接任第一副會長，第一副會長接任會長，任期均為一年。</p>
        <p>4.	第一副會長、第二副會長、第三副會長，無特定理由，不接掌職務者需罰款伍萬元整，可不用繼續接任，罰款金額需存入專戶基金（從缺遞補之三、二、一副會長需繳交遞補職位之職務捐款，存入專戶基金）。</p>
        <h2>第九條：新會員入會審核</h2>
        <p>1.	申請新加入的會員，經本會會員推薦或招募，須參加理、監事聯席會議、月例會一次以上，經過審核小組（當屆會長、創會會長、前任會長、第一、二三副會長六人小組）審查通過後，並繳交入會費新台幣壹萬元、壹年會費新台幣參萬伍仟元及會館基金新台幣壹仟元始可入會，在當屆上半年6至11月份加入者應繳交壹年會費新台幣：參萬陸仟元整；在當屆下半年12至5月份加入者應繳交半年會費新台幣：壹萬捌仟元整（界定上半年加入或下半年加入、以報名入300B2區之時間為準）。</p>
        <p>2.	申請加入本會會員入會前應詳讀本會章程及內規細則，對本會章程及內規須深刻瞭解並遵守條文，於章程及內規細則簿上簽名後，方能成為正式會員。</p>
        <h2>第十條：首席正副代表產生方式</h2>
        <p>1.	正副代表參加上級會議所需經費一律由本會支付。</p>
        <p>2.	當屆會長為當然首席正代表，如因故無法參加，由第一副會長代理。</p>
        <p>3.	正代表第一順位為會長，第二順位為在B2區擔任總監、第一、二副總監、前任總監、專、分區主席、秘書長、財務長，第三順位為第一副會長，第四順位為前任會長，第五順位為秘書，第六順位為財務，第七順位為總管，第八順位為聯絡，第九順位按副代表產生順序遞補。</p>
        <p>4.	副代表第一順位為依前項所列順位沒有擔任正代表之人員，第二順位為第二副會長、第三順位為第三副會長，第四順位為常務監事，第五順位為常務理事，第六順位按連絡簿順序。</p>
        <p>5.	正副代表參加上級會議所得之物品除禮物歸私人所有外，現金、金飾（轉賣為現金）需存入本會專戶基金，歸會所有。</p>
        <h2>第十一條：婚喪喜慶辦理</h2>
        <p>1.	本會會員本人或子女，嫁娶致贈禮金新台幣叁仟陸百元。</p>
        <p>2.	本會會員或直系血親不幸喪亡，本會致贈奠儀新台幣參仟伍佰元。</p>
        <p>3.	本會會員公司開業或開店、新屋落成、榮任政府立案單位之職務者致贈禮金新台幣參仟陸百元或等值紀念品、牌匾。</p>
        <p>4.	本會會員參加政府單位之選舉競選總部成立、輔導會及第十分區各友會交接、授證需致贈花籃時，費用上限為新台幣壹仟伍佰元。（章程及內規細則規定外的致贈不得使用本會之會費）。</p>
        <p>5.	本會會員達以上情事時，應由當事人或法定繼承人提出請帖或訃聞，交由本會轉發各位獅兄，禮儀由各位獅兄自由致贈禮金或奠儀，視個人意願致贈，不得強制規定。但每逢喪事，會長須帶內閣人員先去探望。</p>
        <p>6.	會員逢喪事者，在中南部需動用到遊覽車時，車費、餐費保險費及過路費由喪家出。</p>
        <p>7.	婚喪喜慶以會員暨配偶、會員父母、子女三代為主。</p>
        <p>8.	本會會員及配偶因病住院，由會長組團探望，致送水果、禮盒或鮮花致意（以不超過新台幣壹仟元為限）。</p>
        <h2>第十二條：會員調解</h2>
        <p>本會設調解委員會，調解會員間之糾紛。由當局會長、創會會長、前任會長、第一、二、三副會長及內閣人員擔任調解委員，任期一年。</p>
        <h2>第十三條：不得招會及金錢借貸</h2>
        <p>1.	為維護本會團結和諧及永續經營，會員嚴禁招會及向會員金錢借貸情事（個人私交除外）。</p>
        <p>2.	會員挑撥離間、製造是非、散播謠言、耳語者，第一次被查到則應辦桌請客道歉，第二次被查到者，經理、監事聯席會議提議，並經會長或前任會長提請全體會員二分之一以上聯署同意後，取消其會員資格。</p>
        <p>3.	會員及其配偶嚴禁在會內搞小團體，經勸不聽者，經理、監事聯席會議題義，並經會長或前任會長提請全體會員二分之一以上連署同意後，取消其會員資格。</p>
        <p>4.	違反上述規定者，依本會章程第十條第2項之規定取消其會員資格。</p>
        <h2>第十四條：本會財產物品之管理</h2>
        <p>1.	本會財產物品由創會會長負責列冊保管，並逐屆移交需帳務相符，遺失或不足由當屆會長補償後，經由常務監事監督下方能移交給接任會長，移交後在帳、物冊上應各自簽名以示負責。</p>
        <p>2.	本會設專戶基金存摺簿、會務費用存摺簿各壹本，印鑑為會印章、會長印章、秘書印章、財務印章，共同用印方能領款使用，印章各自保管並負完全責任（帳款不足或遺失由當屆會長概括承受補足）。</p>
        <p>3.	本會在世界總會、台灣總會、300B2區等所得獎牌，由當屆會長領回保管。</p>
        <h2>第十五條：國內外旅遊活動</h2>
        <p>1.	本會每屆由會長舉辦國內至少兩天一夜旅遊活動壹次由會編列預算補助每位參加活動會員新台幣貳仟元。</p>
        <p>2.	本會每屆國外旅遊活動，由會長決定是否辦理，如要辦理須經理、監事聯席會議討論通過後據以辦理。</p>
        <p>3.	會員之親屬、朋友均能參加國內外旅遊活動，惟需繳交各人全額旅費。</p>
        <p>附則：會員有事無法參與國內旅遊活動者，可由獅嫂代理參加會員及獅嫂未能參加者自動喪失其補助權利」。</p>
        <h2>第十六條：國內兄弟會</h2>
        <p>本會於2020年5月31日與國際獅子會300A2區台北市日月光獅子會締結兄弟會，兩會訂定備忘錄以做為確認雙方締結之依據：</p>
        <p>1.	兩會每届互訪，於各會未來之舉辦交接（授證）典禮時，且另邀請互訪一次，日期由各會自行決定，若其中間因特殊事由而需要正式訪問，經事先協議，使得進行。</p>
        <p>2.	就兩會交接典禮時，致贈社會服務金由兩會當屆會長決定，且金額相等。</p>
        <p>3.	就上述正式訪問所需要之各雜費（如交通、酒水、用餐及其他費用），原則上由受訪分會自行負擔。</p>
        <p>4.	若兩會所在地發生天災，且在其國家或縣市發布災害特別措時，盡速進行適當的救助活動。</p>
        <p>5.	就本備忘錄項目若將來認為需要更改（包括修改或補加），兩會經各理事會同意後，得更改之。</p>
        <p>6.	本備忘僅作兩會內部守則之用，不提交國際獅子會或兩會所屬之主管機關。</p>
        <p>7.	其它上記項目以外之事項發生時，委任當届之會長、秘書處理。</p>
        <p>8.	有關訪問會與受訪會間之紀念品贈送原則：</p>
        <p>會與會間互贈紀念品，當屆會長間互贈紀念品，結盟會長間互贈紀念品，二會間之會員不須互贈紀念品。</p>
        <p>＊必締結證書，由當屆會長保管併隨著會長交接。</p>
        <h2>第十七條：國際交流（國外姊、妹會結盟）</h2>
        <p>本會目前未結盟國外姊、妹會，待結盟後依雙方合約再另訂定細則，提送會員大會審查通過後執行。</p>
        <h2>第十八條：附則</h2>
        <p>本會內規細則於2009年經會員大會通過後訂定，再於第二、三屆會員大會修改訂定後實施，若有未盡事宜需另行修正，應經當屆理、監事聯席會議提案討論通過後，並由理事會提送當屆4月份會員大會提案審查通過後方得修改實施。</p>
      </div>
    </div>
    <div class="sys-01">
      <div
        v-for="item in filteredMenu7"
        :key="item.class"
      >
      <div class="info"></div>
        <h2>〈雙和十九  卓越長久_會長歐陽毅 服務心語〉</h2>

        <p>「溫暖，是我們行動的名字；長久，是我們不變的約定。」</p>

        <p>承蒙獅友信任，接任第十九屆會長一職，心懷感恩，更深知責任之重。感謝歷屆會長與前輩們奠定穩固基石，讓雙和穩步前行。未來一年，願與全體獅友同行，讓「服務」不僅是行動，更成為我們共同的價值與日常。</p>

        <p>本屆將以三大方向穩健推進：</p>

        <h3>一、扎根在地_擴展服務深度與廣度</h3>
        <p>延續五大志業八大社會服務主軸，推動「雙和愛心日」，每月走入社區第一線，主動發掘需求，讓服務更即時、更有溫度。</p>

        <h3>二、整合資源_放大公益影響力</h3>
        <p>串聯社福機構與醫療體系，建立跨域合作模式，使服務由點成線、由線成面，實踐「愛無界、行無限」。</p>

        <h3>三、制度傳承_凝聚團隊向心力</h3>
        <p>建立服務成果分享與交流機制，強化內部連結，讓每一份付出被看見、被肯定，讓雙和精神世代延續。</p>

        <p>我深信</p>
        <p>服務，是一條需要同行的路；</p>
        <p>信任，是一種值得用行動回應的託付。</p>

        <p>未來一年，我將以最謙遜的心、最堅定的步伐，與各位獅兄、獅嫂及寶眷們攜手前行，為雙和寫下第十九屆最溫暖且長久的篇章。</p>

        <p>雙和獅子會第十九屆會長</p>
        <p>歐陽毅 敬筆</p>

      </div>
    </div>   
    <div class="sys-01">
      <div
        v-for="item in filteredMenu8"
        :key="item.class"
      >
      <div class="info"></div>
        <h2>2026/5/31</h2>
        <p>交接晚會於狀元樓。</p>

      </div>
    </div>   
    <div class="sys-01">
      <div
        v-for="item in filteredMenu10"
        :key="item.class"
      >
      <div class="info"></div>
        <h2>建言、有委屈>>聯繫會長 歐陽毅</h2>
        <h2>提案、調記錄>>聯繫秘書 彭翊誠</h2>        
        <h2>會費、要請款>>聯繫財務 卓子雁</h2>
        <h2>找人、想報名>>聯繫聯絡 福哥</h2>
        <h2>器材、欲借用>>聯繫總務 林靖騰</h2>
        <h2>以上、找不到>>助理秘書 蘇美玉</h2>                
      </div>
    </div>   

    <div class="sys-01">
      <div
        v-for="item in filteredMenu9"
        :key="item.class"
      >
      <vue-pdf-embed
        :source="source"
        :page="pageNum"
        @loaded="handleLoaded"
      />

      <div class="info"></div>
        <button @click="prevPage">上一页</button>
        <button @click="nextPage">下一页</button>
        <span>{{ pageNum }} / {{ pageCount }}</span>             
      </div>
    </div>      

    <div class="sys-01">
      <div
        v-for="item in filteredMenu11"
        :key="item.class"
      >
      <vue-pdf-embed
        :source="source11"
        :page="pageNum"
        @loaded="handleLoaded"
      />

      <div class="info"></div>
        <button @click="prevPage">上一页</button>
        <button @click="nextPage">下一页</button>
        <span>{{ pageNum }} / {{ pageCount }}</span>             
      </div>
    </div> 



  </div>
</template>

<script setup>
import { ref, computed } from "vue";

import VuePdfEmbed from 'vue-pdf-embed';
const source = ref('/sample.pdf'); // PDF地址
const source11 = ref('/Record.pdf'); // PDF地址
const pageNum = ref(1);
const pageCount = ref(1);

const handleLoaded = (pdf) => {
  pageCount.value = pdf.numPages; // 获取总页数
};

const prevPage = () => {
  if (pageNum.value > 1) pageNum.value--;
};

const nextPage = () => {
  if (pageNum.value < pageCount.value) pageNum.value++;
};


const currentSize = ref(24);
const currentSizeA = ref(16);

const categories = ["關於","議程","記錄","團隊","歷屆","會員","榮者","章程","內規", "洽我"];
const activeCategory = ref("關於");
const openCart = ref(false);


const menu1 = ref([
  { id: 1, name: "", image: '/img/icons/pictures/C-01.png' },
  { id: 2, name: "", image: '/img/icons/pictures/C-02.png' },
  { id: 4, name: "", image: '/img/icons/pictures/C-04.png' },
  { id: 5, name: "", image: '/img/icons/pictures/C-05.png' },
  { id: 6, name: "", image: '/img/icons/pictures/C-06.png' },
  { id: 7, name: "", image: '/img/icons/pictures/C-07.png' },
  { id: 8, name: "", image: '/img/icons/pictures/C-08.png' },
]);

const menu2 = ref([
  {  name: "", image: '/img/icons/pictures/D-03.jpg' },
  {  name: "", image: '/img/icons/pictures/D-04.jpg' },
  {  name: "", image: '/img/icons/pictures/D-05.png' },
  {  name: "", image: '/img/icons/pictures/D-06.png' },
  {  name: "", image: '/img/icons/pictures/D-07.png' },
  {  name: "", image: '/img/icons/pictures/D-08.png' },
  {  name: "", image: '/img/icons/pictures/D-09.jpg' },
  {  name: "", image: '/img/icons/pictures/D-10.png' },
  {  name: "", image: '/img/icons/pictures/D-11.png' },
  {  name: "", image: '/img/icons/pictures/D-12.png' },
  {  name: "", image: '/img/icons/pictures/D-13.png' },    
  {  name: "", image: '/img/icons/pictures/D-15.png' },       
  {  name: "", image: '/img/icons/pictures/D-17.png' },
  {  name: "", image: '/img/icons/pictures/D-18.png' },    
]);

const menu3 = ref([
  { id: 3, name: "", image: '/img/icons/pictures/E-03.jpg' },
  { id: 4, name: "", image: '/img/icons/pictures/E-04.jpg' },
  { id: 5, name: "", image: '/img/icons/pictures/E-05.jpg' },
  { id: 6, name: "", image: '/img/icons/pictures/E-06.png' },
  { id: 7, name: "", image: '/img/icons/pictures/E-07.png' },
  { id: 8, name: "", image: '/img/icons/pictures/E-08.jpg' },
  { id: 9, name: "", image: '/img/icons/pictures/E-09.png' },
  { id: 12, name: "", image: '/img/icons/pictures/E-12.jpg' },
  { id: 13, name: "", image: '/img/icons/pictures/E-13.jpg' },
  { id: 14, name: "", image: '/img/icons/pictures/E-14.png' },
  { id: 15, name: "", image: '/img/icons/pictures/E-15.png' },
  { id: 16, name: "", image: '/img/icons/pictures/E-16.jpg' },
  { id: 18, name: "", image: '/img/icons/pictures/E-18.jpg' },
  { id: 18, name: "", image: '/img/icons/pictures/E-20.png' },
  { id: 18, name: "", image: '/img/icons/pictures/E-21.png' },
  { id: 18, name: "", image: '/img/icons/pictures/E-22.png' },
  { id: 18, name: "", image: '/img/icons/pictures/E-23.png' },        
]);

const menu4 = ref([
  { id: 1, name: "", image: '/img/icons/pictures/N-01.jpg' },
  { id: 2, name: "", image: '/img/icons/pictures/N-02.jpg' },
  { id: 3, name: "", image: '/img/icons/pictures/N-03.jpg' },
  { id: 4, name: "", image: '/img/icons/pictures/N-04.jpg' },
  { id: 5, name: "", image: '/img/icons/pictures/N-05.jpg' },
  { id: 6, name: "", image: '/img/icons/pictures/N-06.jpg' },
  { id: 7, name: "", image: '/img/icons/pictures/N-07.jpg' },
  { id: 8, name: "", image: '/img/icons/pictures/N-08.jpg' },
  { id: 9, name: "", image: '/img/icons/pictures/N-09.jpg' },
  { id: 10, name: "", image: '/img/icons/pictures/N-10.jpg' },
  { id: 11, name: "", image: '/img/icons/pictures/N-11.jpg' },
  { id: 12, name: "", image: '/img/icons/pictures/N-12.jpg' },
  { id: 13, name: "", image: '/img/icons/pictures/N-13.jpg' },
  { id: 14, name: "", image: '/img/icons/pictures/N-14.jpg' },
]);

const menu5 = ref([
  { id: 1, name: "", image: '/img/icons/pictures/F-01.jpg' },
  { id: 2, name: "", image: '/img/icons/pictures/F-02.jpg' },
  { id: 3, name: "", image: '/img/icons/pictures/F-03.jpg' },
  { id: 4, name: "", image: '/img/icons/pictures/F-04.jpg' },
  { id: 5, name: "", image: '/img/icons/pictures/F-05.jpg' },
]);

const memo1 = ref([
  { message : '鍾新民' },
]);

const memo2 = ref([
  { message : '鍾新民' },
]);

const memo3 = ref([
  { message : '鍾新民' },
]);

const memo4 = ref([
  { message : '鍾新民' },
]);

const memo5 = ref([
  { message : '鍾新民' },
]);

const memo6 = ref([
  { message : '鍾新民' },
]);


const filteredMenu = computed(() =>
  menu1.value.filter(m => activeCategory.value === "團隊" || m.category === activeCategory.value) 
);

const filteredMenu1 = computed(() =>
  menu2.value.filter(m => activeCategory.value === "歷屆" || m.category === activeCategory.value)
);

const filteredMenu2 = computed(() =>
  menu3.value.filter(m => activeCategory.value === "會員" || m.category === activeCategory.value)
);

const filteredMenu3 = computed(() =>
  menu4.value.filter(m => activeCategory.value === "新血" || m.category === activeCategory.value)
);

const filteredMenu4 = computed(() =>
  menu5.value.filter(m => activeCategory.value === "榮者" || m.category === activeCategory.value)
);

const filteredMenu5 = computed(() =>
  memo1.value.filter(m => activeCategory.value === "章程" || m.category === activeCategory.value)
);

const filteredMenu6 = computed(() =>
  memo2.value.filter(m => activeCategory.value === "內規" || m.category === activeCategory.value)
);

const filteredMenu7 = computed(() =>
  memo3.value.filter(m => activeCategory.value === "關於" || m.category === activeCategory.value)
);

const filteredMenu8 = computed(() =>
  memo4.value.filter(m => activeCategory.value === "預告" || m.category === activeCategory.value)
);

const filteredMenu9 = computed(() =>
  memo5.value.filter(m => activeCategory.value === "議程" || m.category === activeCategory.value)
);

const filteredMenu10 = computed(() =>
  memo6.value.filter(m => activeCategory.value === "洽我" || m.category === activeCategory.value)
);

const filteredMenu11 = computed(() =>
  memo6.value.filter(m => activeCategory.value === "記錄" || m.category === activeCategory.value)
);

const cart = ref([]);

const addToCart = (item) => {
  const found = cart.value.find(c => c.id === item.id);
  if (found) found.qty++;
  else cart.value.push({ ...item, qty: 1 });
};





const cartTotal = computed(() =>
  cart.value.reduce((t, i) => t + i.price * i.qty, 0)
);


</script>

<style scoped>
.app {
  max-width: 480px;
  margin: auto;
  background: #fafafa;
  min-height: 100vh;
  padding-bottom: 90px;
}
.header {
  padding: 1px;
  text-align: center;
  background: hsl(34, 100%, 63%);
  color: white;
}
.tabs {
  display: flex;
  overflow-x: auto;
  padding: 8px;
  gap: 8px;
}
.tab {
  padding: 8px 14px;
  border-radius: 20px;
  border: 1px solid #ddd;
  background: white;
}
.tab.active {
  background: hsl(34, 100%, 63%);
  color: white;
}
.product-list {
  padding: 0px;
  display: grid;
  gap: 0px;
}
.card {
  display: flex;
  gap: 10px;
  background: white;
  border-radius: 10px;
  padding: 10px;
}
.thumb {
  width: 341px;
  height: 263px;
  border-radius: 8px;
  object-fit: cover;
}
.thumb {
  width: 341px;
  height: 263px;
  border-radius: 8px;
  object-fit: cover;
}
.thumb1 {
  width: 341px;
  height: 263px;
  border-radius: 8px;
  object-fit: cover;
}
.thumb2 {
  width: 341px;
  height: 263px;
  border-radius: 8px;
  object-fit: cover;
}
.thumb3 {
  width: 341px;
  height: 263px;
  border-radius: 8px;
  object-fit: cover;
}
.thumb4 {
  width: 341px;
  height: 263px;
  border-radius: 8px;
  object-fit: cover;
}



.info {
  flex: 1;
}
.info1 {
  flex: 1;
}
.info2 {
  flex: 1;
}
.info3 {
  flex: 1;
}
.info4 {
  flex: 1;
}

.desc {
  color: #777;
  font-size: 12px;
}
.bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  align-items: center;
}
.price {
  font-weight: bold;
}
.add {
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  background: hsl(34, 100%, 63%);
  color: white;
}
.cart-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 16px;
  border-radius: 30px;
  background: #222;
  color: white;
  border: none;
}
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.5);
  display: grid;
  place-items: center;
}
.panel {
  background: white;
  padding: 16px;
  width: 90%;
  max-width: 420px;
  border-radius: 12px;
}
.cart-item {
  display: flex;
  justify-content: space-between;
  margin: 6px 0;
}
.cart-item1 {
  display: flex;
  justify-content: space-between;
  margin: 6px 0;
}
.total {
  margin-top: 10px;
  font-weight: bold;
}
.checkout {
  width: 100%;
  padding: 10px;
  margin-top: 8px;
  background: hsl(34, 100%, 63%);
  color: white;
  border: none;
  border-radius: 8px;
}
.close {
  width: 100%;
  padding: 8px;
  margin-top: 6px;
}
</style>



